import React, { FC } from 'react';

import * as BlockableComponents from '../../../types/blockable-components';
import { Options } from '../components/Options';

export const SingleSelect: FC<BlockableComponents.SingleSelect> = (props) => {
  return <Options wrapperClassName='mt-3' {...props} mode='single' />;
};
